import { useState } from 'react';
import { useIntl } from 'react-intl';

import { IconButton, Island, Typography } from '@bolteu/clay-react';
import { InfoCircle, Minus } from '@bolteu/kalep-react-icons';
import { Popover } from '@provider-portal/design-common/clay/components/Popover';

import { $tk } from 'utils/appTranslationKey';

export function OnboardingProviderSupport() {
  const { formatMessage } = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed right-[15px] bottom-[15px]">
      <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
        <Popover.Trigger
          render={
            <IconButton
              variant="primary"
              size="lg"
              className="shadow-md"
              icon={isOpen ? <Minus /> : <InfoCircle />}
            />
          }
        />
        <Popover.Portal>
          <Popover.Positioner side="top" align="end" sideOffset={8} collisionPadding={8}>
            <Popover.Popup>
              <Island elevation="floor-2" className="max-w-[350px] p-8">
                <Typography defaultTag="p" className="m-0 mb-4 bolt-font-body-m-regular">
                  {formatMessage({ id: $tk.onboardingProvidersSupport.message1 })}
                </Typography>
                <Typography defaultTag="p" className="m-0 mb-4 bolt-font-body-m-regular">
                  {formatMessage({ id: $tk.onboardingProvidersSupport.message2 })}
                </Typography>
                <Typography defaultTag="p" className="m-0 bolt-font-body-m-regular">
                  {formatMessage({ id: $tk.onboardingProvidersSupport.message3 })}
                </Typography>
              </Island>
            </Popover.Popup>
          </Popover.Positioner>
        </Popover.Portal>
      </Popover.Root>
    </div>
  );
}
